var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.style)},[_c('div',{ref:"pr",staticClass:"lo"})])
}
var staticRenderFns = []

export { render, staticRenderFns }